import { findLastIndex } from 'utils/functional';
import _ from 'lodash';

const useComputedValuesOfDriverDay = (driverDay) => {
  const stops = driverDay?.stops;
  const journeyIds = driverDay?.journeys?.map(({ id }) => id);

  const allVehicles = driverDay?.journeys?.reduce((acc, journey) => [...acc, journey.vehicle], []);

  const vehiclesPerJourney = driverDay?.journeys?.reduce(
    (acc, { id, vehicle }) => ({
      ...acc,
      [id]: vehicle,
    }),
    {}
  );

  const sameVehicleForAllJourneys =
    _.uniq(allVehicles?.map((vehicle) => vehicle?.id))?.length === 1;

  const firstStopIndexesByJourney = journeyIds?.reduce((acc, journeyId) => {
    return {
      ...acc,
      [journeyId]: [...stops].findIndex((stop) => stop.journey_id === journeyId),
    };
  }, {});

  const lastStopIndexesByJourney = journeyIds?.reduce((acc, journeyId) => {
    return {
      ...acc,
      [journeyId]: findLastIndex(stops)((stop) => stop.journey_id === journeyId),
    };
  }, {});

  const _getVehicleForStop = (stop, stopIndex) => {
    if (sameVehicleForAllJourneys && stopIndex === 0) {
      return vehiclesPerJourney[stop.journey_id];
    }

    if (sameVehicleForAllJourneys && stopIndex !== 0) {
      return null;
    }

    const isFirstStopOfTheJourney = firstStopIndexesByJourney[stop.journey_id] === stopIndex;
    const hasVehicle = !!vehiclesPerJourney[stop.journey_id];
    if (isFirstStopOfTheJourney && hasVehicle) {
      return vehiclesPerJourney[stop.journey_id];
    }

    if (isFirstStopOfTheJourney && !hasVehicle) {
      return {
        error: 'no_vehicle',
      };
    }

    return null;
  };

  const vehicleByStopIndex = stops?.reduce((acc, stop, stopIndex) => {
    return {
      ...acc,
      [stopIndex]: _getVehicleForStop(stop, stopIndex),
    };
  }, {});

  const isFirstStopOfJourney = (stopIndex, journeyId) => {
    return firstStopIndexesByJourney[journeyId] === stopIndex;
  };

  const isLastStopOfJourney = (stopIndex, journeyId) => {
    return lastStopIndexesByJourney[journeyId] === stopIndex;
  };

  const shipperOrderIdsPerJourney = driverDay?.journeys?.reduce(
    (acc, journey) => ({
      ...acc,
      [journey.id]: [
        ...(acc[journey.id] || []),
        ...journey.shipper_orders.map((shipper_order) => shipper_order.id),
      ],
    }),
    {}
  );

  return {
    vehiclesPerJourney,
    firstStopIndexesByJourney,
    lastStopIndexesByJourney,
    shipperOrderIdsPerJourney,
    vehicleByStopIndex,
    isFirstStopOfJourney,
    isLastStopOfJourney,
  };
};

const useComputedValuesOfDriverDayJourney = (journeys) => {
  return journeys?.map((journey) => {
    const shipper_names = journey?.shipper_orders?.map(
      (shipperOrder) => shipperOrder.shipper_company_name
    );
    return {
      ...journey,
      shipper_company_name: journey?.shipper_orders?.[0]?.shipper_company_name,
      shipper_names,
    };
  });
};

export { useComputedValuesOfDriverDay, useComputedValuesOfDriverDayJourney };
